const STAGE = '[data-bd-stage]';
const POPUP = '[data-bd-popup]';
const BALLOONS_KEY = 'bd-balloons-seen';
const POPUP_KEY = 'bd-popup-seen';
const MOBILE_QUERY = '(max-width: 749px)';
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const END_BUFFER = 400;
const FADE_MS = 900;

const seen = (key) => {
  try {
    return window.sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
};

const markSeen = (key) => {
  try {
    window.sessionStorage.setItem(key, '1');
  } catch {
  }
};

const remove = (el) => el?.remove();

const initBalloons = () => {
  const stage = document.querySelector(STAGE);
  if (!stage) return;

  if (seen(BALLOONS_KEY) || window.matchMedia(REDUCED_MOTION_QUERY).matches) {
    remove(stage);
    return;
  }
  markSeen(BALLOONS_KEY);

  const isMobile = window.matchMedia(MOBILE_QUERY).matches;
  const duration =
    Number(isMobile ? stage.dataset.durationMobile : stage.dataset.durationDesktop) || 0;

  window.setTimeout(() => {
    stage.classList.add('bd-stage--out');
    window.setTimeout(() => remove(stage), FADE_MS);
  }, duration + END_BUFFER);
};

const initPopup = () => {
  const popup = document.querySelector(POPUP);
  if (!popup) return;

  if (seen(POPUP_KEY)) {
    remove(popup);
    return;
  }
  markSeen(POPUP_KEY);

  const close = () => {
    popup.classList.remove('bd-popup--open');
    window.setTimeout(() => remove(popup), 320);
    document.removeEventListener('keydown', onKeydown);
  };

  const onKeydown = (event) => {
    if (event.key === 'Escape') close();
  };

  popup.hidden = false;
  window.requestAnimationFrame(() => popup.classList.add('bd-popup--open'));

  popup.querySelector('.bd-popup__close')?.addEventListener('click', close);
  document.addEventListener('keydown', onKeydown);

  popup.querySelector('.bd-popup__close')?.focus({ preventScroll: true });
};

const init = () => {
  initBalloons();
  initPopup();
};

init();

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  if (seen(BALLOONS_KEY)) remove(document.querySelector(STAGE));
  if (seen(POPUP_KEY)) remove(document.querySelector(POPUP));
});
